<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="900" scrollable>
    <v-card>
      <v-card-title class="dialog-title">
        {{ $t('org-dashboard.dq-drilldown-title') }}
        <v-spacer />
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-0">
        <v-data-table
          :headers="tableHeaders"
          :items="items"
          :server-items-length="totalItems"
          :options.sync="internalOptions"
          :loading="loading"
          :no-data-text="$t('org-dashboard.dq-no-issues')"
          :footer-props="{
            'items-per-page-options': [10, 20, 50],
          }"
          @update:options="onOptionsChange"
          class="drilldown-table"
        >
          <template v-slot:item.identifier="{ item }">
            <a class="drilldown-link" @click.stop="$emit('charger-click', item.id)">{{ item.identifier }}</a>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DashboardDataQualityDrilldown',
  props: {
    value: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    totalItems: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      internalOptions: { page: 1, itemsPerPage: 20 },
    }
  },

  computed: {
    tableHeaders() {
      return [
        { text: this.$t('org-dashboard.dq-col-identifier'), value: 'identifier' },
        { text: this.$t('org-dashboard.dq-col-location'), value: 'locationName' },
        { text: this.$t('org-dashboard.dq-col-issue'), value: 'issue' },
        { text: this.$t('org-dashboard.dq-col-last-activity'), value: 'lastActivity' },
        { text: this.$t('org-dashboard.dq-col-duration'), value: 'duration' },
      ]
    },
  },

  methods: {
    onOptionsChange(options) {
      this.internalOptions = options
      this.$emit('update:options', options)
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-title {
  font-size: 16px;
  font-weight: 700;
  border-bottom: 1px solid #e5e7eb;
}

.drilldown-table {
  ::v-deep .v-data-table__wrapper {
    max-height: 500px;
    overflow-y: auto;
  }
}

.drilldown-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    color: #1565c0;
    text-decoration-thickness: 2px;
  }
}
</style>
